import * as React from 'react';
import { ThemeProvider } from '@mui/material/styles';
import { BaseApp, useBaseAppContext } from '@programari-limit/base-react';
import AppRoutes from './AppRoutes';
import useAppLogic from './hooks/useAppLogic';
import defaultLogo from './assets/logo.png';
import defaultHeaderBackground from './assets/headerBackground.jpg';
import SelectorIdioma from 'components/SelectorIdioma';
import { useLocation, matchPath } from 'react-router-dom';
import routeTitles from 'AppRoutesTitles';

const App = () => {
    const { temporalMessageComponent, setCurrentLanguage } = useBaseAppContext();
    const location = useLocation();
    const {
        appTheme,
        appHeaderStyle,
    } = useAppLogic('#32814B', defaultHeaderBackground);

    // Permet establir un titol dinàmic a cada ruta aixi com es va navegant per l'aplicació
    React.useEffect(() => {
        const currentPath = location.pathname;
    
        const matchedEntry = Object.entries(routeTitles).find(([pattern]) =>
            matchPath(pattern, currentPath)
        );
    
        const title = matchedEntry?.[1] || 'Creuers';
        document.title = `${title} | Creuers`;
    }, [location]);
    
    React.useEffect(()=> {
        const idioma = (navigator.language || navigator.userLanguage)?.split('-')[0];
        setCurrentLanguage(idioma)
    },[])

    return <ThemeProvider theme={appTheme}>
        <BaseApp
            image={defaultLogo}
            headerStyle={appHeaderStyle}
            name={'Creuers'}
            additionalHeaderComponent={<SelectorIdioma />}
            minWidthZero>
            <AppRoutes />
            {temporalMessageComponent}
        </BaseApp>
    </ThemeProvider>;
}

export default App;